import { render, staticRenderFns } from "./insta-feed.vue?vue&type=template&id=14f0a33a&"
import script from "./insta-feed.vue?vue&type=script&lang=js&"
export * from "./insta-feed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Work\\AbdulMalikYoosufani\\BondhEShams\\BondhEShams\\BondhEShams.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14f0a33a')) {
      api.createRecord('14f0a33a', component.options)
    } else {
      api.reload('14f0a33a', component.options)
    }
    module.hot.accept("./insta-feed.vue?vue&type=template&id=14f0a33a&", function () {
      api.rerender('14f0a33a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue-app/public/components/instagram/insta-feed.vue"
export default component.exports